import request from '@/utils/request'

let Profession_catalogApi = {

  /*工种分类列表*/
  list(data) {
    return request._post('/shop/plus.profession_catalog.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.profession_catalog.Index/indexx', data);
},
/*添加工种分类*/
add(data) {
    return request._post('/shop/plus.profession_catalog.Index/add', data);
},
/*修改工种分类*/
edit(data) {
    return request._post('/shop/plus.profession_catalog.Index/edit', data);
},
/*删除工种分类*/
del(data) {
    return request._post('/shop/plus.profession_catalog.Index/del', data);
},
/*工种分类详情*/
detail(data) {
  return request._post('/shop/plus.profession_catalog.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.profession_catalog.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.profession_catalog.Setting/getSetting', data, errorback);
    },
}
export default Profession_catalogApi;



// WEBPACK FOOTER //
// ./src/api/profession_catalog.js